import React, { Component } from "react";
import _ from "lodash";
import numeral from "numeral";
import ReactLoading from "react-loading";

import { Button, Image, Modal, SocialLink } from "../../components";
import { withRedux } from "../../hoc";
import { fetchApi } from "../../utils";

const backgroundModal = `${process.env.PUBLIC_URL}/assets/images/background-noti-modal.png`;

const mapStateToProps = ({ language, t }) => {
  return {
    language,
    t,
  };
};

@withRedux(mapStateToProps)
export default class BookingStep4 extends Component {
  state = {
    openModal: false,
    fetchQrcode: null,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState) {
    console.log(
      "componentDidUpdate",
      this.props.bookingInfo,
      prevProps.bookingInfo,
      prevState.fetchQrcode
    );

    if (this.props.bookingInfo !== prevProps.bookingInfo) {
      this.handleOpenModal();
    }

    if (_.isEmpty(prevState.fetchQrcode)) {
      this.fetchBookingInfoDelay();
    }
  }

  fetchBookingInfo = async (key) => {
    return fetchApi(`booking/info?key=${encodeURIComponent(key)}`, "POST");
  };

  fetchBookingInfoDelay = async () => {
    const { successKey } = this.props;
    const bookingInfo = await this.fetchBookingInfo(successKey);
    if (_.get(bookingInfo, "status") === "success") {
      this.setState({
        fetchQrcode: _.get(bookingInfo, ["data", "qrcode"]),
      });
    }
  };

  handleOpenModal = async () => {
    const { successKey } = this.props;
    this.setState({ openModal: true });
    _.delay(async () => {
      this.fetchBookingInfoDelay();
    }, 2500);
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  renderModal = () => {
    const { t } = this.props;
    const { openModal } = this.state;
    return (
      <Modal
        className="noti-modal"
        type="custom"
        centered
        visible={openModal}
        onCancel={this.handleCloseModal}
        okText={t("Ok")}
        backgroundColor="#000000"
        backgroundOpacity={0.9}
      >
        <div className="container-image">
          <div className="noti-modal-text-block">
            <div className="sec-1">
              <h2>THANK YOU FOR YOUR RESERVATION</h2>
              <p>WE ARE HAPPY TO SEE YOU SOON</p>
            </div>
            <div className="sec-2">
              <p>
                PLEASE CHECK YOUR EMAIL FOR RESERVATION TICKET, ANY ISSUE PLEASE
                CONTACT DIRECTLY TO RESERVATIONS DEPARTMENT
              </p>
            </div>
            <div className="sec-3">
              <h3>
                PHONE: <a href="tel:+6638421700,5">(+66) 38-421-700 to 5</a>,{" "}
                <a href="tel:+6638429642">(+66) 38-429-642</a>
              </h3>
              <h3>
                EMAIL:{" "}
                <a href="mailto:res@tiffany-show.co.th">
                  res@tiffany-show.co.th
                </a>
              </h3>
            </div>
          </div>
          <div className="background-filter" />
          <Image className="background-image" src={backgroundModal} alt="" />
        </div>
      </Modal>
    );
  };

  render() {
    const { bookingInfo, t } = this.props;
    const { fetchQrcode, openModal } = this.state;

    const name = _.get(bookingInfo, "customerName");
    const email = _.get(bookingInfo, "customerEmail");
    const isAgent = _.get(bookingInfo, "isAgent");
    const agentName = _.get(bookingInfo, "AgentName");
    const date = _.get(bookingInfo, "showDate");
    const time = _.get(bookingInfo, "showTime");
    const sumBySeatNoPrice = _.sumBy(_.get(bookingInfo, "seatNoList"), "price");
    const totalSeatNoPrice = numeral(sumBySeatNoPrice).format("0,0");
    const groupSeats = _.groupBy(
      _.get(bookingInfo, "seatNoList"),
      "seatTypeName"
    );
    const foodDrinkList = _.get(bookingInfo, "foodDrinkList", []);
    const sumByFoodDrinkPrice = _.sumBy(
      _.get(bookingInfo, "foodDrinkList"),
      "totalPrice"
    );
    const totalFoodDrinkPrice = numeral(sumByFoodDrinkPrice).format("0,0");

    const grandTotalPrice = numeral(
      sumBySeatNoPrice + sumByFoodDrinkPrice
    ).format("0,0");

    const qrcode = fetchQrcode;
    const pdfETicket = _.get(bookingInfo, "pdfETicket");
    const pdfAbbtax = _.get(bookingInfo, "pdfAbbtax");
    const pdfFulltax = _.get(bookingInfo, "pdfFulltax");

    // console.log("RENDER STEP 4 ::", { bookingInfo, groupSeats, fetchQrcode });
    return (
      <div className="booking-step-4">
        {!openModal && (
          <React.Fragment>
            {_.isEmpty(fetchQrcode) && (
              <div className="preload-info-block">
                <div className="preload-info-holder">
                  <ReactLoading type="spinningBubbles" color="#fff" />
                </div>
              </div>
            )}
          </React.Fragment>
        )}
        <div className="container-summary">
          <div className="row">
            <div className="col-lg-7 col-md-12">
              <div className="title-block">
                <h2>{t("Thank you for your payment")}</h2>
                <p className="summary-description">
                  {t(
                    "You will shortly receive a confirmation email with a QR code to collect your tickets at Tiffany's Show Pattaya. If you have not received your confirmation email within 10 minutes, please check your junk/spam email folder."
                  )}
                </p>
              </div>
              <div className="detail-block">
                {isAgent && (
                  <p>
                    {t("Agent Name")} : <span>{agentName}</span>
                  </p>
                )}
                <p>
                  {t("Name")} : <span>{name}</span>
                </p>
                <p>
                  {t("Email")} : <span>{email}</span>
                </p>
                <div className="code-block">
                  <Image src={qrcode} alt="" />
                </div>
                <div className="description-block">
                  <p>{t("To connect with us")}:</p>
                </div>
                <div className="contect-block">
                  <p>
                    {t("Website")} :
                    <a
                      href="https://www.tiffany-show.co.th"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>www.tiffany-show.co.th</span>
                    </a>
                  </p>
                  <p>
                    {t("Telephone")} :{" "}
                    <a href="tel:(+66) 38421700 to 5">
                      <span>(+66) 38421700 to 5</span>
                    </a>
                  </p>
                  <p>
                    {t("Email")} :{" "}
                    <a href="mailto:res@tiffany-show.co.th">
                      <span>res@tiffany-show.co.th</span>
                    </a>
                  </p>

                  <div className="social-info">
                    <SocialLink.Facebook />{" "}
                    <a
                      href="https://www.facebook.com/tiffanyshowpattaya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>TiffanyShowPattaya</span>
                    </a>
                  </div>
                  <div className="social-info">
                    <SocialLink.Instagram />{" "}
                    <a
                      href="https://www.instagram.com/tiffanysshowpattaya"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>TiffanysShowpattaya</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="summary-block">
                <div className="item">
                  <div className="row">
                    <div className="col-7">
                      <p className="question">{t("Date & Showtime")}</p>
                    </div>
                    <div className="col-5" style={{ paddingLeft: 0 }}>
                      <p>
                        <i className="fa fa-calendar" />
                        {date}
                      </p>
                      <p>
                        <i className="fa fa-clock-o" />
                        {time}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="seat-block">
                  <div className="seat-group-detail">
                    <p className="question">{t("Selected Seats")}</p>
                    <p className="question">{t("Price")}</p>
                  </div>
                  {_.map(groupSeats, (group, key) => {
                    return (
                      <div key={key} className="seat-deatil-block">
                        <p className="seat-name">{key}</p>
                        <div className="seat-group-detail">
                          <div className="item-info">
                            {_.map(group, (item, index) => {
                              const seatNo = _.replace(
                                _.get(item, "seatNo"),
                                " ",
                                ""
                              );
                              return (
                                <p key={index} className="seat-no">
                                  {seatNo}
                                </p>
                              );
                            })}
                          </div>
                          <div className="item-info">
                            <p className="seat-no">
                              {numeral(_.sumBy(group, "price")).format("0,0")}{" "}
                              {t("THB")}
                              {/* {totalPrice} {t("THB")} */}
                            </p>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="total-block">
                    <p className="question">{t("Total Price")}</p>
                    <p className="question" style={{ color: "white" }}>
                      ฿ {totalSeatNoPrice} {t("THB")}
                    </p>
                  </div>
                </div>
                <div className="seat-block">
                  <div className="seat-group-detail">
                    <p className="question">{t("Selected Food & Drinks")}</p>
                    <p className="question">{t("Price")}</p>
                  </div>
                  {_.size(foodDrinkList) > 0 &&
                    _.map(foodDrinkList, (item, key) => {
                      return (
                        <div key={key} className="seat-deatil-block">
                          <div className="seat-group-detail">
                            <div className="item-info">
                              <p className="seat-no">
                                {_.get(item, "itemName")}
                              </p>
                            </div>
                            <div className="item-info">
                              <p className="seat-no">
                                {_.get(item, "totalPrice")} {t("THB")}
                              </p>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  {_.size(foodDrinkList) <= 0 && (
                    <div className="seat-deatil-block">
                      <div className="seat-group-detail">
                        <div className="item-info">
                          <p className="seat-no">-</p>
                        </div>
                        <div className="item-info" />
                      </div>
                    </div>
                  )}
                  <div className="total-block">
                    <p className="question">{t("Total Price")}</p>
                    <p className="question" style={{ color: "white" }}>
                      ฿ {totalFoodDrinkPrice} {t("THB")}
                    </p>
                  </div>
                </div>
                <div className="grand-total-block">
                  <p className="question">{t("Grand Total")}</p>
                  <p className="question" style={{ color: "white" }}>
                    ฿ {grandTotalPrice} {t("THB")}
                  </p>
                </div>
                <div className="button-block">
                  {pdfETicket && (
                    <a
                      href={pdfETicket}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ display: "block" }}
                    >
                      <Button ghost bordercolor="#ffb400">
                        {t("Download QR Code File")} (.pdf){" "}
                        <i className="fa fa-download" />
                      </Button>
                    </a>
                  )}
                  {pdfAbbtax && (
                    <a
                      href={pdfAbbtax}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginTop: 10, display: "block" }}
                    >
                      <Button ghost bordercolor="#ffb400">
                        {t("Download ABB Tax File")} (.pdf){" "}
                        <i className="fa fa-download" />
                      </Button>
                    </a>
                  )}
                  {pdfFulltax && (
                    <a
                      href={pdfFulltax}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginTop: 10, display: "block" }}
                    >
                      <Button ghost bordercolor="#ffb400">
                        {t("Download Full Tax File")} (.pdf){" "}
                        <i className="fa fa-download" />
                      </Button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.renderModal()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Booking/BookingStep4.js